<script lang="ts" setup>
import { computed } from "vue"
import { useRoute } from "vue-router"
import { useAppStore } from "@/store/modules/app"
import { useTagsViewStore } from "@/store/modules/tags-view"
import { useViewScopeStore } from "@/store/modules/viewScope"

const route = useRoute()
const tagsViewStore = useTagsViewStore()
const appStore = useAppStore()
const viewScopeStore = useViewScopeStore()

const key = computed(() => {
  return `${route.path}:${viewScopeStore.contextVersion}`
})

// 检查是否为order页面且侧边栏隐藏
const isOrderFullscreen = computed(() => {
  return route.path.includes('/business/order/') && appStore.sidebar.hidden
})
</script>

<template>
  <section class="app-main" :class="{ 'order-fullscreen': isOrderFullscreen }">
    <router-view v-slot="{ Component }">
      <keep-alive :include="tagsViewStore.cachedViews">
        <component :is="Component" :key="key" />
      </keep-alive>
    </router-view>
  </section>
</template>

<style lang="scss" scoped>
.app-main {
  position: relative;
  width: 100%;
  height: calc(100vh - var(--v3-navigationbar-height));
  overflow: hidden;
  background-color: var(--tea-component-app-main-bg-color);
  background-image: var(--tea-component-app-main-bg-image);
  background-size: var(--tea-component-app-main-bg-size);
  background-blend-mode: var(--tea-component-app-main-bg-blend-mode);
}

.fixed-header + .app-main {
  height: 100vh;
  padding: var(--tea-component-app-main-padding);
  padding-top: calc(
    var(--v3-navigationbar-height) + var(--tea-component-app-main-padding)
  );
  overflow: auto;
}

.hasTagsView {
  .app-main {
    min-height: calc(100vh - var(--v3-header-height));
  }

  .fixed-header + .app-main {
    padding-top: calc(var(--v3-header-height) - 6px);
  }
}

// order页面全屏样式
.order-fullscreen {
  padding: 0 !important;
  margin: 0 !important;
  overflow: visible !important;
}

// 当order页面全屏时，覆盖其他样式
.fixed-header + .order-fullscreen {
  padding: 0 !important;
}

.hasTagsView .fixed-header + .order-fullscreen {
  padding-top: 0 !important;
}
</style>
